import { render, staticRenderFns } from "./Agencies.vue?vue&type=template&id=06d0844a"
import script from "./Agencies.vue?vue&type=script&lang=js"
export * from "./Agencies.vue?vue&type=script&lang=js"
import style0 from "./Agencies.vue?vue&type=style&index=0&id=06d0844a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports